import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";

function SideBar() {
  const navigate = useNavigate();
  const [masterDropdown, setMasterDropdown] = useState(false);

  return (
    <div className="sidebar">
      <ul className="sidebar-menu">
        <li id="dashboard" onClick={() => navigate("/dashboard")}>
          <i className="fas fa-briefcase"></i> Dashboard
        </li>

        <li
          id="master"
          className="master-menu dropdown-master"
          onClick={() => setMasterDropdown(!masterDropdown)}
        >
          <span>
            <i className="fas fa-briefcase"></i> Master
          </span>
          <i
            className={`fas fa-chevron-down dropdown-toggle ${
              masterDropdown ? "rotated" : ""
            }`}
          ></i>
        </li>
        <ul
          id="master-pages"
          style={{
            display: masterDropdown ? "flex" : "none",
            opacity: masterDropdown ? 1 : 0,
            height: masterDropdown ? "auto" : "0",
          }}
        >
          <li onClick={() => navigate("/category-master")}>Category Master</li>
          <li onClick={() => navigate("/relationship-master")}>
            Relationship Manager Master
          </li>
          <li onClick={() => navigate("/subject-master")}>Subject Master</li>
          {/* <li onClick={() => navigate("/mail-master")}>Mail Master</li>s */}
        </ul>
        <li onClick={() => navigate("/welcome-mail-excel-upload")}>
          <i className="fas fa-briefcase"></i> Welcome Mail (Excel Upload)
        </li>
        <li id="mail" onClick={() => navigate("/sendmail")}>
          <i className="fas fa-briefcase"></i> Send Category Wise Mail
        </li>
        {/* <li id="mail" onClick={() => navigate("/send-lead-mail")}>
          <i className="fas fa-briefcase"></i> Send Mail for New Leads
        </li> */}
        <li id="mail" onClick={() => navigate("/send-lead-mail-excel-upload")}>
          <i className="fas fa-briefcase"></i> Send Mail for New Leads (Excel
          Upload)
        </li>
      </ul>
    </div>
  );
}

export default SideBar;
